import React, { useState, useRef, useEffect } from "react";
import "./DateFilter.css";

export default function DateFilter({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("All");

  const [tempFrom, setTempFrom] = useState(fromDate);
  const [tempTo, setTempTo] = useState(toDate);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  useEffect(() => {
    setTempFrom(fromDate);
    setTempTo(toDate);
  }, [fromDate, toDate]);

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

  const formatLabel = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const applyPreset = (type) => {
  const today = new Date();

  let from = "";
  let to = "";

  switch (type) {
    case "All":
      from = "";
      to = "";
      break;

    case "Today":
      from = formatDate(today);
      to = formatDate(today);
      break;

    case "Yesterday":
      const y = new Date(today);
      y.setDate(today.getDate() - 1);
      from = formatDate(y);
      to = formatDate(y);
      break;

    case "Last 3 Days":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2)
      );
      to = formatDate(today);
      break;

    case "Last 7 Days":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6)
      );
      to = formatDate(today);
      break;

    case "Last 15 Days":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14)
      );
      to = formatDate(today);
      break;

    case "Last 30 Days":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29)
      );
      to = formatDate(today);
      break;

    case "This Month":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth(), 1)
      );
      to = formatDate(today);
      break;

    case "Last Month":
      from = formatDate(
        new Date(today.getFullYear(), today.getMonth() - 1, 1)
      );
      to = formatDate(
        new Date(today.getFullYear(), today.getMonth(), 0)
      );
      break;

    case "This Year":
      from = formatDate(new Date(today.getFullYear(), 0, 1));
      to = formatDate(today);
      break;

    default:
      return;
  }

  // Update UI
  setSelected(type);
  setTempFrom(from);
  setTempTo(to);

  // Apply immediately
  setFromDate(from);
  setToDate(to);

  // Close popup
  setOpen(false);
};

  const handleApply = () => {
    setFromDate(tempFrom);
    setToDate(tempTo);
    setOpen(false);
  };

  const handleCancel = () => {
    setTempFrom(fromDate);
    setTempTo(toDate);
    setOpen(false);
  };

  const title =
    tempFrom && tempTo
      ? `${selected} (${formatLabel(new Date(tempFrom))} - ${formatLabel(
          new Date(tempTo)
        )})`
      : "All";

  const presets = [
    "All",
    "Today",
    "Yesterday",
    "Last 3 Days",
    "Last 7 Days",
    "Last 15 Days",
    "Last 30 Days",
    "This Month",
    "Last Month",
    "This Year",
  ];

  return (
    <div className="date-filter-wrapper" ref={wrapperRef}>
      <button
        className="date-filter-button"
        onClick={() => setOpen(!open)}
      >
        <span>
          <i className="bi bi-calendar3"></i>
          {title}
        </span>

        <i
          className={`bi ${
            open ? "bi-chevron-up" : "bi-chevron-down"
          }`}
        ></i>
      </button>

      {open && (
        <div className="date-popup">

          <div className="preset-list">

            {presets.map((item) => (
              <div
                key={item}
                className={`preset-item ${
                  selected === item ? "active" : ""
                }`}
                onClick={() => applyPreset(item)}
              >
                <span>{item}</span>

                {selected === item && (
                  <i className="bi bi-check-lg"></i>
                )}
              </div>
            ))}

          </div>

          <div className="custom-section">

            <h4>Custom Date Range</h4>

            <div className="field">
              <label>From</label>

              <input
                type="date"
                value={tempFrom}
              onChange={(e) => {
    setSelected("Custom");
    setTempFrom(e.target.value);
}}
              />
            </div>

            <div className="field">
              <label>To</label>

              <input
                type="date"
                value={tempTo}
             onChange={(e) => {
    setSelected("Custom");
    setTempTo(e.target.value);
}}
              />
            </div>

         {selected === "Custom" && (
    <div className="popup-footer">

        <button
            className="cancel-btn"
            onClick={handleCancel}
        >
            Cancel
        </button>

        <button
            className="apply-btn"
            onClick={handleApply}
        >
            Apply
        </button>

    </div>
)}
          </div>

        </div>
      )}
    </div>
  );
}